import React, { useEffect, useRef } from "react";
import { useApp } from "../contexts/AppContext";
import confetti from "canvas-confetti";

export default function FireworksEffect() {
  const { settings } = useApp();
  const timerRef = useRef(null);

  useEffect(() => {
    if (!settings.fireworks_enabled) return;
    const colors = ["#FF6B6B", "#FFD93D", "#005F73", "#2D6A4F", "#FFFFFF", "#FF8C42"];
    const fire = () => {
      const x = 0.1 + Math.random() * 0.8;
      const y = 0.1 + Math.random() * 0.5;
      confetti({
        particleCount: 80,
        startVelocity: 28,
        spread: 360,
        ticks: 90,
        gravity: 0.7,
        scalar: 1.1,
        origin: { x, y },
        colors,
        shapes: ["circle", "star"],
      });
    };
    timerRef.current = setInterval(fire, 2200);
    fire();
    return () => clearInterval(timerRef.current);
  }, [settings.fireworks_enabled]);

  return null;
}
